(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartExport', ChartExport);

    ChartExport.$inject = ['$resource'];

    function ChartExport ($resource) {
        var resourceUrl =  'api/chart-exports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'cancel': { method:'PUT', url: 'api/chart-exports/cancel' }
        });
    }
})();
